
export enum QuoteStatus {
  Draft = 'Draft',
  Quoted = 'Submit',
  ReadyToSend = 'ReadyToSend',
  Submitted = 'Submitted'
}

export enum IntegrationType {
  MFG = 'MFG'
}

export enum TrackingModule {
  QuoteAssist = 'QuoteAssist',
  QuoteSummary = 'QuoteSummary',
  DirectQuoteAssist = 'DirectQuoteAssist',
  DirectQuoteSummary = 'DirectQuoteSummary',
  QuoteAssistV2 = 'QuoteAssistV2',

}

export enum TrackingEvents {
  AssistStarted = 'Started',
  SummaryStarted = 'SummaryStarted',
  SkipAssist = 'SkipAssist',
  SaveToDraft = 'SaveToDraft',
  ProceedSummary = 'ProceedSummary',
  QuoteCreated = 'QuoteCreated',
  Complexity = 'ComplexityDone',
  Materials = 'MaterialDone',
  Tooling = 'ToolingDone',
  ManufacturingProcess = 'ManufacturingProcessDone',
  Machining = 'MachineCostDone',
  Labor = 'SetupCostDone',
  AMR = 'AMRDone',
  Overhead = 'OverheadDone',
  OtherCosts = 'OtherCostDone',
  Shipping = 'ShippingDone',
  Profit = 'ProfitDone',
  ReviewQuote = 'ReviewQuote'
}

export enum MixPanelEvents {
  SaveToDraft = 'supplier quote assist save to draft',
  ProceedSummary = 'quote assist proceed to summary',
  AssistStarted = 'supplier quote assist open',
  SkipAssist = 'supplier quote assist skip to quote',
  QuoteCreated = 'supplier quote assist create quote',
  SummaryStarted = 'supplier quote assist landed on quote summary',
  ReviewQuote = 'supplier quote assist review quote',
  Materials = 'MaterialDone',
  Tooling = 'ToolingDone',
  ManufacturingProcess = 'ManufacturingProcessDone',
  Machining = 'MachineCostDone',
  Labor = 'SetupCostDone',
  AMR = 'AMRDone',
  Overhead = 'OverheadDone',
  OtherCosts = 'OtherCostDone',
  Shipping = 'ShippingDone',
  Profit = 'ProfitDone',
  QuoteDetailsCompletedSelfCreated = 'QAV2 Quote Details Completed Self-created',
  QuoteDetailsCompletedMarketPlace = 'QAV2 Quote Details Completed Marketplace ',
  QuoteDetailsCompletedWebsiteSubmitted = 'QAV2 Quote Details Completed Website Submitted ',
  PartAdded = 'QAV2 New Part Added',
  PartFileAdded = 'QAV2 Part File Added',
  PartQuotingCompletedSelfCreated = 'QAV2 Part Quoting Completed Self-created',
  PartQuotingCompletedMarketPlace = 'QAV2 Part Quoting Completed Marketplace ',
  PartQuotingCompletedWebsiteSubmitted = 'QAV2 Part Quoting Completed Website Submitted ',
  SaveToDraftSelfCreated = 'QAV2 Save to Draft Self-created',
  SaveToDraftMarketPlace = 'QAV2 Save to Draft Marketplace ',
  SaveToDraftWebsiteSubmitted = 'QAV2 Save to Draft Website Submitted ',
  SendViaEmail = 'QAV2 Send via Email',
  DownloadPDfSelfCreated = 'QAV2 Download PDF Self-created',
  DownloadPDfWebsiteSubmitted = 'QAV2 Download PDF Website Submitted ',
  SendViaEmailWebsiteSubmitted = 'QAV2 Send via Email Website Submitted',
  QuoteSubmitted = 'QAV2 Quote Submitted',


}

export enum QuoteAssistDemoVideos {
  WatchDemoButtonClicked = 'QuoteAssistDemo - WatchDemoButtonClicked',
  QuoteAssistDemoStep1 = 'QuoteAssistDemo - Step1Clicked',
  QuoteAssistDemoStep2 = 'QuoteAssistDemo - Step2Clicked',
  QuoteAssistDemoStep3 = 'QuoteAssistDemo - Step3Clicked',
  QuoteAssistDemoStep4 = 'QuoteAssistDemo - Step4Clicked',
  QuoteAssistDemoStep5 = 'QuoteAssistDemo - Step5Clicked',
  QuoteAssistDemoDone = 'QuoteAssistDemo - DoneButtonClicked'
}